import React from 'react';
import WhatsAppWebShared from '../Shared/WhatsAppWebShared';

const WhatsAppWebExecutive = () => {
  return <WhatsAppWebShared roleTitle="Executive" />;
};

export default WhatsAppWebExecutive;
